export default class userFacingString {
  static Strings = {
    emailNotes:
      'Note: We will register this email with us. You can use the email to login in the future.',
    confirmUsageChange: 'Are you sure want to update your usage?',
    selectConsumption: 'Please enter usage to generate quote',
    selectContractEndDate: 'Please select contract end date',
    selectSupplier: 'Please select the supplier name',
    notInTheList: 'notInListDisplaySites',
    notInList: 'NotInTheList',
    gasTarifffMand: 'Please enter the gas tariff',
    dayTarifffMand: 'Please enter the day tariff',
    blankPostCode: 'Please enter the postcode',
    below75: 'Usage should be less than 750000',
    below99: 'Usage should be less than 1000000',
    trywithlesstariff: 'Please try with less spend',
    nightTarifffMand: 'Please enter the night tariff',
    confirmDeleteCompany: 'You will lose the company history if you delete the company.',
    confirmDeleteSite: 'You will lose the site history if you delete the site.',
    confirmDeleteSpends: 'You will lose the spend history if you delete the spend.',
    reasonForDeleteSite: 'Please enter the reason for deleting the site',
    reasonForDeleteCompany: 'Please enter the reason for deleting the company',
    reasonForDeleteSpends: 'Please enter the reason for deleting the spend',
    TncData:
      'Please click to accept the terms and conditions to allow us to fetch your industry data',
    DirectSupplierMessage:
      'Thank you for initiating the contract. Our team will be in touch with you about next steps in the 24 hours.',
    kvaConsumption: 'Please enter kva usage',
    pleaseEnter3:'Please enter a minimum of 3 characters',
    selectFromDropdown: 'Please select business from dropdown.',
    invalidAddressId: 'Given addressId is not recognised. Please use the AddressSearch API again to find the correct parameter',
    errorMessage: "Something went wrong!!! Please try again or if issue persists contact customer care at support@perse.energy.",
    loaError: "We are unable to generate the letter of authority. Please contact us at business@perse.energy",
    contractError: 'Contract generation error. Please contact the administrator',
    quoteExpiredMsg: 'This quote has expired. Please regenerate the quote.',
    noDetailsFoundAddressId: 'No details found for the address id'
  };

  static preferencesData = {
    RatingAny: 'Any',
    RatingFive: '4 Star & Above',
    RatingFour: '3 Star & Above',

    renewableAny: 'Any',
    renewableGreen: '100% Green',
    renewablePartial: 'Partial',

    contractAny: 'Any',
    contractFixed: 'Fixed',
    contractVariable: 'Variable',

    paymentAny: 'Any',
    paymentCash: 'Cash/Cheque',
    paymentDDM: 'Direct Debit (Monthly)',
    paymentDDQ: 'Direct Debit (Quarterly)',
    paymentPP: 'Prepayment',
    paymentBacs: 'BACS',
  };

  static gasElecData = {
    mpanTop: 'MPAN top line',
    mpanBotton: 'MPAN bottom line',
    mpan: 'MPAN',
    AddBottomLine: 'Add bottom line',
    Bottom13Digits: 'Bottom 13 digits of the MPAN',
    MpanInformation:
      'This information can be found in your current electricity bill',
    Length: '13',
    mprn: 'MPRN',
    serialNumber: 'Serial number',
    AddMPRN: 'Add MPRN',
    MprnINF:
      'Your Meter Point Reference Number (MPRN) is the unique 6 to 12 digit number',
    MprnINF2: 'Also called "M" number or meter number',
    MprnLength: '6 - 12',
    invalidSerialNumber: 'Serial number is invalid, please use defferent meter',
  };

  static VATData = {
    withoutVAT: 'withoutVAT',
    VAT5: 'vat5',
    VAT20: 'vat20',
    fivePercent: '5%',
    twentyPercent: '20%',
  };

  static bankValidationSlug = {
    'account-number-invalid': 'Account number is invalid.',
    'no-branch-found': 'No Branch Found'
  }
}
